import { api } from "@/lib/api";

export const INVOICE_FIELDS = [["company_name", "Ragione sociale"], ["vat_number", "Partita IVA"], ["address", "Indirizzo sede"], ["zip", "CAP"], ["city", "Città"], ["province", "Provincia"]];

export const missingInvoiceData = (d = {}) => {
  const out = INVOICE_FIELDS.filter(([k]) => !String(d[k] || "").trim()).map(([, l]) => l);
  if (!String(d.pec || "").trim() && !String(d.sdi || "").trim()) out.push("PEC o codice SDI");
  return out;
};

const MAP = { ragione_sociale: "company_name", partita_iva: "vat_number", codice_fiscale: "fiscal_code", sede_indirizzo: "address", sede_cap: "zip", sede_citta: "city", sede_provincia: "province", pec: "pec" };

const toBase64 = (blob) => new Promise((resolve, reject) => { const r = new FileReader(); r.onload = () => resolve(r.result); r.onerror = reject; r.readAsDataURL(blob); });

// Reads the visura, fills empty profile fields automatically and returns the values that differ from the current profile.
export async function applyVisura(blob, filename) {
  const { data: extracted } = await api.post("/company/extract-visura", { file_base64: await toBase64(blob), filename }, { silent: true, timeout: 95000 });
  const found = extracted?.data || extracted || {};
  const { data: profile } = await api.get("/account/profile");
  const current = profile.data || {};
  const fill = {}, differ = {};
  Object.entries(MAP).forEach(([src, dst]) => {
    let v = found[src];
    if (v == null || !String(v).trim()) return;
    v = String(v).trim();
    if (dst === "province") { v = v.replace(/[()]/g, "").trim().toUpperCase(); if (!/^[A-Z]{2}$/.test(v)) return; }
    if (dst === "vat_number") v = v.replace(/^IT/i, "").replace(/\D/g, "");
    if (!String(current[dst] || "").trim()) fill[dst] = v;
    else if (String(current[dst]).trim().toLowerCase() !== v.toLowerCase()) differ[dst] = v;
  });
  if (Object.keys(fill).length) await api.put("/account/profile", fill);
  return { filled: Object.keys(fill), differ };
}
